export interface BaseShiftState {
  shiftName: string;
  shiftDateStart: string;
  shiftDateEnd: string;
  timeStart: string;
  timeEnd: string;
  location: string;
  shiftLead: string;
  shiftLeadId: number | null;
  roles: string;
  supplementaryType: string;
  requiredVolunteers: number;
  minVolunteers: number;
  description: string;

  updateShiftName: (name: string) => void;
  updateShiftDateStart: (date: string) => void;
  updateShiftDateEnd: (date: string) => void;
  updateTimeStart: (time: string) => void;
  updateTimeEnd: (time: string) => void;
  updateLocation: (location: string) => void;
  updateShiftLead: (lead: string, leadId: number | null) => void;
  updateRoles: (roles: string) => void;
  updateSupplementaryType: (type: string) => void;
  updateRequiredVolunteers: (num: number) => void;
  updateMinVolunteers: (num: number) => void;
  updateDescription: (description: string) => void;
}

export const convertDayToDate = (date: string) => {
  return date === "Friday"
    ? "2026-09-18"
    : date === "Saturday"
    ? "2026-09-19"
    : "2026-09-20";
};
